import { SurgirhoverListProps } from "../SurgirhoverList/SurgirhoverList";

export const menuItems: SurgirhoverListProps['menuItems'] = [
    {
        "title": "Nosotros",
        "children": true,
        "link": "",
        "sections": [
            {
                "icon": "shape",
                "title": "¿Quiénes somos?",
                "options": [
                    {
                        "title": "Fondos Colectivos",
                        "description": " ",
                        "link": "/quienes-somos",
                        "targetBlank": false,
                        "keywords": "qué es surgir, quiénes somos"
                    },
                    {
                        "title": "¿Cómo funciona Fondos Colectivos?",
                        "description": " ",
                        "link": "/como-funciona",
                        "targetBlank": false,
                        "keywords": "qué es surgir, quiénes somos"
                    }

                ]
            },
            {
                "icon": "shape",
                "title": "Grupo Santander",
                "options": [
                    {
                        "title": "Banco Santander Perú",
                        "description": " ",
                        "link": "https://www.santander.com.pe/",
                        "targetBlank": true,
                        "keywords": "Banco Santander Perú"
                    },
                    {
                        "title": "Santander Consumer",
                        "description": " ",
                        "link": "https://www.santanderconsumer.com.pe/",
                        "targetBlank": true,
                        "keywords": "Santander Consumer"
                    },
                    {
                        "title": "Surgir",
                        "description": " ",
                        "link": "https://www.surgir.com.pe/",
                        "targetBlank": true,
                        "keywords": "Santander Consumer"
                    },
                    {
                        "title": "NeoAuto",
                        "description": " ",
                        "link": "https://neoauto.com/",
                        "targetBlank": true,
                        "keywords": "Santander Consumer"
                    },
                    {
                        "title": "Santander en el Mundo",
                        "description": " ",
                        "link": "https://www.santander.com/es/home",
                        "targetBlank": true,
                        "keywords": "Santander Mundo"
                    }
                ]
            }
        ]
    },
    {
        "title": "Productos",
        "children": true,
        "link": "",
        "sections": [
           
        
            {
                "icon": "financing",
                "title": "Autos",
                "options": [
                    {
                        "title": "Nuevos",
                        "description": "",
                        "link": "/auto-nuevo",
                        "targetBlank": false,
                        "keywords": "Crédito Mujeres Unidas"
                    },

                   
                ]
            },
           
        ]
    },
    {
        "title": "Canales de Pago",
        "children": true,
        "link": "",
        "sections": [
            {
                "icon": "payment-dollar",
                "title": "Pagar mis cuotas",
                "options": [
                    {
                        "title": "Pago de Cuotas",
                        "description": "",
                        "link": "/pagos",

                        "targetBlank": true,
                        "keywords": "Dónde pago, canales de pago, Pagar mis cuotas"
                    }
                   
                ]
                
            }
        ]
    },
    
    {
        "title": "Ayuda y contacto",
        "children": true,
        "link": "",
        "sections": [
            {
                "icon": "call-support",
                "title": "Te atendemos",
                "options": [
                  
                    {
                        "title": "Canales de Atención",
                        "description": "",
                        "link": "/donde-estamos",
                        "targetBlank": false,
                        "keywords": "Zona de Cobertura"
                    },
                 
                ]
            },
            {
                "icon": "deal-handshake",
                "title": "Te ayudamos",
                "options": [
                  
                    {
                        "title": "Preguntas Frecuentes",
                        "description": "",
                        "link": "/asociados",
                        "targetBlank": false,
                        "keywords": "Preguntas Frecuentes"
                    },
                    {
                        "title": "Requerimientos y Reclamos ",
                        "description": "",
                        "link": "/reclamos-y-requerimientos",
                        "targetBlank": false,
                        "keywords": "Requerimientos y Reclamos, libro de reclamaciones"
                    },  {
                        "title": "Canal Abierto",
                        "description": "",
                        "link": "/canal-abierto",
                        "targetBlank": false,
                        "keywords": "Preguntas Frecuentes"
                    },
                   
                ]
            }
        ]
    },
  
    
    {
        "title": "Zona de Asociados",
        "children": true,
        "link": "",
        "sections": [
            {
                "icon": "call-support",
                "title": "Asociados",
                "options": [
                    {
                        "title": "Comunicados",
                        "description": "",
                        "link": "/asociados#comunicados",
                        "targetBlank": false,
                        "keywords": "Contáctanos, atención"
                    },

                    {
                        "title": "Programas",
                        "description": "",
                        "link": "/asociados",
                        "targetBlank": false,
                        "keywords": "Contáctanos, atención"
                    },
                    {
                        "title": "Contratos y Tarifas",
                        "description": "",
                        "link": "/asociados#contratos-y-tarifas",
                        "targetBlank": false,
                        "keywords": "Zona de Cobertura"
                    },
                    {
                        "title": "Asambleas",
                        "description": "",
                        "link": "/asociados#asamblea",
                        "targetBlank": false,
                        "keywords": "Dónde están ubicados"
                    },{
                        "title": "Propuesta de Remates",
                        "description": "",
                        "link": "https://remates.sistemaffcc.com/",
                        "targetBlank": true,
                        "keywords": "Dónde pago, canales de pago, Pagar mis cuotas"
                    },{
                        "title": "Firma Digital de Documentos",
                        "description": "",
                        "link": "https://firma.sistemaffcc.com/",
                        "targetBlank": true,
                        "keywords": "Firma"
                    }
                ]
            },
            {
                "icon": "deal-handshake",
                "title": "Conoce más",
                "options": [
                    {
                        "title": "Transparencia",
                        "description": "",
                        "link": "/transparencia",
                        "targetBlank": false,
                        "keywords": "Contáctanos, atención"
                    },

                    {
                        "title": "Preguntas Frecuentes",
                        "description": "",
                        "link": "/asociados#preguntas-frecuentes",
                        "targetBlank": false,
                        "keywords": "Requerimientos y Reclamos, libro de reclamaciones"
                    },
                   
                ]
            }
        ]
    },
    {
        "title": "Cotiza Ahora",
        "children": true,
        "link": "/canaldigital",
        "sections": []
    },
]